import * as Backend from '@/core/backend'

export class CorporationDetail {
  constructor (data) {
    if (data) {
      this.CorporationId = data.CorporationId
      this.Name = data.Name
      this.Id = data.Id
      this.Value = data.Value
      this.Data1 = data.Data1
      this.Data2 = data.Data2
      this.Data3 = data.Data3
    }
  }

  async save () {
    if (process.env.NODE_ENV === 'development') console.log('--> CorporationDetail: Saving Corporation Detail: ', this)
    const res = await Backend.callApi({
      apiName: 'Admin.SaveCorporationDetail',
      inputData: {
        CorporationDetail: this
      }
    })
    return res
  }

  static async load (corporationId, name) {
    if (process.env.NODE_ENV === 'development') console.log('--> CorporationDetail: Loading Corporation Detail: ', corporationId, name)
    const res = await Backend.callApi({
      apiName: 'Admin.LoadCorporationDetail',
      inputData: {
        CorporationId: corporationId,
        DetailName: name
      }
    })
    let corporationDetail = null
    // console.log('--> CorporationDetail: Load promise from ' + name, res)
    if (res && res.data) {
      corporationDetail = await new CorporationDetail(res.data)
    } else {
      corporationDetail = await new CorporationDetail({ CorporationId: corporationId, Name: name })// Since we want a new CorporationDetail, create one to work with
    }
    // console.log('--> CorporationDetail: Loaded  CorporationDetail: ', CorporationDetail)
    return corporationDetail
  }

  // todo: Bør hedde noget mere sigende, fx loadDetail
  static async loadFromUser (name) {
    if (process.env.NODE_ENV === 'development') console.log('--> CorporationDetail: Loading Corporation Detail ' + name + ' without corpId: ', name)
    const res = await Backend.callApi({
      apiName: 'Admin.LoadCorporationDetail',
      inputData: {
        DetailName: name
      }
    })
    let corporationDetail = null
    // console.log('--> CorporationDetail: Load promise from ' + name, res)
    if (res && res.data) {
      corporationDetail = await new CorporationDetail(res.data)
    } else {
      corporationDetail = await new CorporationDetail({ Name: name })// Since we want a new CorporationDetail, create one to work with
    }
    // console.log('--> CorporationDetail: Loaded  CorporationDetail: ', CorporationDetail)
    return corporationDetail
  }

  static async loadAllFromUser () {
    // if (process.env.NODE_ENV === 'development') console.log('--> CorporationDetail: Loading Corporation Detail ' + name + ' without corpId: ', name)
    const res = await Backend.callApi({
      apiName: 'Admin.LoadAllCorporationDetail',
      inputData: {
      }
    })
    const corporationDetails = []
    if (res.failed) {
      return corporationDetails
    }
    // console.log('--> CorporationDetail: Load promise from ' + name, res)
    if (res && res.data) {
      for (let i = 0; i < res.data.length; i++) {
        corporationDetails[i] = await new CorporationDetail(res.data[i])
      }
    } /* else {
      corporationDetail = await new CorporationDetail({ Name: name })// Since we want a new CorporationDetail, create one to work with
    } */
    // console.log('--> CorporationDetail: Loaded  CorporationDetail: ', CorporationDetail)
    return corporationDetails
  }

  static async saveAllForUser (data) {
    if (process.env.NODE_ENV === 'development') console.log('--> CorporationDetail: Saving Corporation Detail: ', data)
    const res = await Backend.callApi({
      apiName: 'Admin.SaveAllCorporationDetail',
      inputData: {
        CorporationDetails: data
      }
    })
    return res
  }
}
